"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const usePostMessage_1 = require("./usePostMessage");
function useSetServerStatus() {
    return (0, usePostMessage_1.default)('setServerStatusOk');
}
exports.default = useSetServerStatus;
